import './index.scss'
import {Modes} from '../../tree-model/index'
export default {
  name: 'sy-tree-node',
  props: {
    index: {type: Number},
    source: {type: Object}, // 当前 Node
    multiple: {type: Boolean},
    expandedNodeKeys: {type: Object},
    expand: {type: Function},
    collapse: {type: Function},
    labelClick: {type: Function},
    checkboxClick: {type: Function},
    mustLeaf: {type: Boolean},
    focusNode: {type: Boolean},
    selectedNodeSingle: {type: Object},
    itemRender: {type: Function, default: null},
    // 项的内容宽度撑开
    contentWidthFull: {type: Boolean, default: false},
    // 是否展示有选中子酸节点的指示器（小蓝点）
    progenyIndicator: {type: Boolean, default: true},
    // 线条模式
    showLine: {type: Boolean, default: false},
    // 数据联动的模式，多选时使用
    mode: {type: String, default: Modes.TWO_WAY}
  },
  methods: {
    _expandClick (node) {
      if (this.expandedNodeKeys[node.key]) {
        this.collapse(node)
      } else {
        this.expand(node)
      }
    },
    _getPrefixWidth (node) {
      if (this.showLine) {
        return node.level * 24 + 6 + (this.multiple ? 21 : 0)
      } else {
        return (node.level - 1) * 24 + 22 + (this.multiple ? 16 : 0)  
      }
    },
    // todo remove
    _getIndentUnits (num) {
      const arr = []
      for (let i = 0; i !== num; i++) {
        arr.push(<span class="sy-tree__indent-unit"></span>)
      }
      return arr
    },
    _getSwitcherUI () {
      return <span class={'sy-tree__switcher'} on-click={() => this._expandClick(this.source)}>
        {
          !this.source.isLeaf
            ? this.source.loading
              ? <i class={'el-icon-loading'}></i>
              : !this.showLine
                ? <i class={`el-icon-caret-right sy-tree__switcher-icon ${this.expandedNodeKeys[this.source.key] ? 'sy-tree__switcher-icon--close' : ''}`}></i>
                : <i class={`iconfont ${this.expandedNodeKeys[this.source.key] ? 'icon-shuxingshouqi' : 'icon-shuxingzhankai'}`}></i>
            : null
        }
      </span>
    },
    _getLineLeafSwitcherUI () {
      return <span class={'sy-tree__switcher'}>
        <span class="sy-tree__switcher--line-leaf"></span>
      </span>
    }
  },
  render () {
    const contentStyle = {}
    if (this.contentWidthFull) {
      contentStyle['width'] = `calc(100% - ${this._getPrefixWidth(this.source)}px)`
      contentStyle['box-sizing'] = 'border-box'
    }
    const nodeClass = ['sy-tree__node']
    this.source.disabled && nodeClass.push('sy-tree__node--disabled')
    this.showLine && nodeClass.push('sy-tree__node--line')
    this.source.parent.childNodes[this.source.parent.childNodes.length - 1] === this.source && nodeClass.push('sy-tree__node--last')
    return (
      <div class={nodeClass}>
        {
          // indent
          !this.showLine 
            ? <span class={'sy-tree__indent'} style={{'width': `${(this.source.level - 1) * 24}px`}}></span>
            : <span class={'sy-tree__indent'}>
              {
                // this._getIndentUnits(this.source.level - 1)
                [...Array(this.source.level - 1)].map(_ => {
                  return <span class="sy-tree__indent-unit"></span>
                })
              }
            </span>
        }
  
        {
          // switcher
          !this.showLine || !this.source.isLeaf
              ? this._getSwitcherUI()
              : this._getLineLeafSwitcherUI()
        }
        
        {
          this.multiple && (!this.mustLeaf || this.source.isLeaf) && 
          <el-checkbox 
            class={'sy-tree__checkbox'} 
            disabled={this.source.disabled} 
            v-model={this.source.checked} 
            indeterminate={this.mode === Modes.TWO_WAY && !this.source.checked && this.source.indeterminate} 
            on-change={() => this.checkboxClick(this.source)}>
          </el-checkbox>
        }
        {/*{*/}
        {/*  this.source.indeterminate && <span class={`sy-tree__spot sy-tree__spot--highlight`}></span>*/}
        {/*}*/}
        {
          <span 
            class={`sy-tree__spot ${this.progenyIndicator && this.source.indeterminate ? 'sy-tree__spot--highlight' : ''}`}>
          </span>
        }
        
        {
          // 行内容渲染: 默认渲染或自定义渲染
          <span
            class={`sy-tree__label ${(this.multiple ? this.source === this.focusNode : this.source === this.selectedNodeSingle) ? 'sy-tree__label--highlight' : ''}`}
            style={contentStyle}
            on-click={() => this.labelClick(this.source)}>
            {
              this.itemRender
                ? this.itemRender({node: this.source, data: this.source.data})
                : this.source.label
            }
          </span>
        }
      </div>
    )
  }
}
